// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"FontColorControl_colorPicker__2hU6V"};